import { render, staticRenderFns } from "./FrontPageHeroWide.vue?vue&type=template&id=94d8b44e&"
import script from "./FrontPageHeroWide.vue?vue&type=script&lang=js&"
export * from "./FrontPageHeroWide.vue?vue&type=script&lang=js&"
import style0 from "./FrontPageHeroWide.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports